// extracted by mini-css-extract-plugin
module.exports = {"title":"FooterAddress_title__Mby8E","address":"FooterAddress_address__LTdVU"};